export default __webpack_public_path__ + "static/media/no-transaction.cd1c870f.svg";